<template>
  <div>
    <NavBar :navbar-links="navbarLinks" globe-color="white" @showNavbar="setnavbarHide" />
    <router-view></router-view>
  </div>
</template>

<script>
import { navbarLinks } from '@src/constants/general-constants'
import NavBar from '@src/components/misc/Navbar.vue'
import generalMixin from '@src/mixins/general-mixins.js'

export default {
  components: {
    NavBar,
  },
  mixins: [generalMixin],
  data() {
    return {
      navbarLinks,
    }
  },
}
</script>